export const toCapitalize = text => {
  return text?.charAt(0)?.toUpperCase() + text?.slice(1)
}

export const removeSpaceText = text => {
  return text?.replace(/\s/g, "")
}

export const toCamelCase = text => {
  return text?.replace(/\s/g, "_")
}

export const getFileType = fileName => {
  const imageExtensions = /\.(jpg|jpeg|png|gif|bmp|svg|webp)$/i
  const videoExtensions = /\.(mp4|mov|avi|mkv|webm|flv|wmv|m4v)$/i

  if (imageExtensions.test(fileName)) {
    return "image"
  } else if (videoExtensions.test(fileName)) {
    return "video"
  } else {
    return null
  }
}
